<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import axios from "axios";
import { todoMethods } from "@/state/helpers";
import { tableData } from "./dataAdvancedtable";
import Fields from '@/helpers/fields';

import Vue from 'vue';
import VueSweetalert2 from 'vue-sweetalert2';
// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);

export default {
  page: {
    title: "Usuario Admin",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },

  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      filters: {
        total: { value: "", keys: ["total"] },
      },
      post: [],

      // ************************************** Link
      tableData: tableData,
      title: "Usuario Admin",
      items: [
        {
          text: "Escritorio",
          href: "/",
        },
        {
          text: "Usuario Admin",
          active: true,
        },
      ],

      tableAdminUser: [],
      info: null,
      showModal: false,
      isLoading: false,
      fullPage: true,
      canCancel: false,
      totalRows: 1,
      todoTotalRows: 1,
      currentPage: 1,
      todocurrentPage: 1,
      current: 1,
      perPage: 10,
      statData: 1,
      todoperPage: 10,
      pageOptions: [10, 25, 50, 100],
      todoOptions: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortBy: "age",
      sortDesc: false,
      useSlot: false,
      loader: "spinner",
      color: "#007bff",
      bgColor: "#FFFFFF",
      height: 128,
      width: 128,
      timeout: 3000, //ms
      fetchingStats: true,
      earningStatus: true,
      userAdminFields: Fields.usuariosAdminFields,
      tipo_usuario: 0,
      negocios: [],
      nombre_negocio: "",
      opciones: [
        { text: 'Todos', value: 0 },
        { text: 'Administrador', value: 1 },
        { text: 'Empresa', value: 2 },
        { text: 'Negocio', value: 3 },
        { text: 'Capturista', value: 4 },
        { text: 'Municipio', value: 6 },
        { text: 'Gerente', value: 7 },
        { text: 'Admin Municipio', value: 8 },
      ]
    };
  },

  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.tableData.length;
    },
    
    permit() {
      // give me the value of permit in permits local storage
      const permits = JSON.parse(localStorage.getItem("permits"));
      if(permits.permit === 'admin') return 1
      else if (permits.permit === 'empresa') return 2
      else if (permits.permit === 'negocio') return 3
      else if (permits.permit === 'punto') return 4
      else if (permits.permit === 'municipio') return 6
      else if (permits.permit === 'gerente') return 7
      else if (permits.permit === 'admin_municipio') return 8
      else return 0
    },

    /**
     * Todo list of records
     */
    // todoList() {
    //   return this.todos.length;
    // },
    getUsuariosAdminAdminUser() {
      // filter by type user 
      if(this.tipoUsuario == 0) {
        // filter by type user except id_tipo equal to 5
        return this.tableAdminUser.filter((item) => item.id_tipo != 5);
      } else {
        return this.tableAdminUser.filter((item) => {
          return item.id_tipo === this.tipoUsuario
        });
      }
    },
    opcionesTipoUsuario() {
      return this.permit == 7 ? [{text: "Negocio", value: 3}] : this.permit === 8 ? [{text: "Admin Municipio", value: 9}] : this.opciones 
    },
    tipoUsuario() {
      return this.permit == 7 ? 3 : this.permit === 8 ? 8 : this.tipo_usuario;
    },
  },

  mounted() {
    this.getUsuariosAdmin();
    document.getElementById("b_table_useradmins").firstElementChild.classList.add("table-light");
  },

  methods: {
    getUsuariosAdmin() {
      axios
        .get(
          "/usuarios_admin"
        )
        .then((response) => {
          this.response = response.data.data;
          this.tableAdminUser = response.data.data;
          console.log(response);
        });
    },
    ...todoMethods,

    getTipoUsuario(id_tipo) {
      if(id_tipo == 1) {
        return "Administrador";
      } else if(id_tipo == 2) {
        return "Empresa";
      } else if(id_tipo == 3) {
        return "Negocio";
      } else if(id_tipo == 4) {
        return "Punto de Venta";
      } else if(id_tipo == 6) {
        return "Municipio";
      } else if(id_tipo == 7) {
        return "Gerente";
      } else {
        return "Usuario";
      }
    },

    handleEdit(id_usuario){
      this.$router.push({
        name:'ActualizaUsuarioAdmin',
        params:{
          id_usuario
        }
      })
    },

    handleDelete(id_usuario) {
      this.$swal({
        title: "¿Estas seguro de borrar?",
        text: "",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, borrar",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.isConfirmed) {
          axios.put("/usuarios", { id_usuario, active: "0" })
            .then((res) => {
              const { response = "" } = res.data;
              if (response === true) {
                this.$swal(
                  "Eliminado",
                  "Usuario eliminado correctamente",
                  "success"
                );
                this.$router.push({ name: "UsuariosAdmin" });
                this.getUsuariosAdmin();
              } else {
                this.$swal("Alertas", "No se pudo eliminar", "warning");
              }
            })
            .catch((err) => {
              console.log(err);
              this.$swal("Error", "Ocurrio un error", "error");
            });
        }
      });
    },

    handleInput(value, data) {
      this.editableDataItems[data.index][data.field.key] = value;
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-lg-12">
        <v-card>
          <div class="card-body">
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <h4 class="card-title mb-4">Lista de usuarios</h4>
              </div>
              <div class="col-sm-12 col-md-6 text-md-end">
                <router-link to="/NuevoUsuarioAdmin">
                  <v-btn
                    depressed
                    color="primary"
                    type="button"
                    id="button-addon2"
                    href="/"
                  >
                    Nuevo registro
                  </v-btn>
                </router-link>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-sm-12 col-md-2">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Ver
                    <v-divider class="mx-1" inset vertical></v-divider>
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select>
                    <v-divider class="mx-1" inset vertical></v-divider>
                    registros
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-3">
                <div class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Tipo de usuario: 
                    <v-divider class="mx-1" inset vertical></v-divider>
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="tipo_usuario"
                      size="sm"
                      :options="opcionesTipoUsuario"
                    ></b-form-select>
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-7">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Buscar:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Buscar..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- tableAdminUser table -->
            <b-table
              id="b_table_useradmins"
              :fields="userAdminFields"
              :items="getUsuariosAdminAdminUser"
              :filter="filter"
              :current-page="current"
              :per-page="perPage"
            >
              <template #cell(id_usuario)="data">
                <a href="javascript: void(0);" class="text-body fw-bold">
                  {{ data.item.id_usuario }}
                </a>
              </template>
              <template #cell(id_tipo)="data">
                <span class="text-body fw-bold">
                  {{ getTipoUsuario(data.item.id_tipo) }}
                </span>
              </template>
              <template #cell(nombrepaternomaterno)="data">
                {{ data.item.nombre }} {{ data.item.apellido_paterno }} {{ data.item.apellido_materno }}
              </template>
              <template #cell(estatus)="data">
                <span
                  class="badge badge-pill bg-success font-size-11"
                  :class="{
                    'bg-warning': `${data.item.estatus}` === '0',
                    'bg-success': `${data.item.estatus}` === '1',
                  }"
                  >{{ data.item.estatus === 1 ? "Activo" : "Desactivo" }}</span
                >
              </template>
              <template #cell(edit)="data">
                <v-btn
                  icon small
                  @click="handleEdit(data.item.id_usuario)"
                >
                  <i style="color: #09a5c7" class="bx bxs-pencil"></i>
                </v-btn>
                <v-btn
                  icon small
                  @click="handleDelete(data.item.id_usuario)"
                >
                  <i style="color: #e73484" class="bx bx-trash"></i>
                </v-btn>
              </template>
            </b-table>
          </div>
          <div class="row mt-4">
            <div class="col-sm-12 col-md-6">
              <v-divider class="mx-2" inset vertical></v-divider>
              Mostrando {{ currentPage }} de {{ totalRows }} registros
            </div>
            <div class="col-sm-12 col-md-6 text-md-end">
              <b-pagination
                v-model="current"
                :total-rows="getUsuariosAdminAdminUser.length"
                :per-page="perPage"
                first-text="Primera"
                prev-text="Anterior"
                next-text="Siguiente"
                last-text="Última"
              >
              </b-pagination>
            </div>
          </div>
        </v-card>
      </div>
    </div>
    <!-- end col -->

    <!-- end row -->
  </Layout>
</template>
